<template>
  <div class="chart-container" :style="'height: ' + height + 'px'">
    <template v-if="dataIsLoaded">
      <canvas :id="canvasId"></canvas>
    </template>
  </div>
</template>

<script>
import {Chart} from 'chart.js';

export default {
  name: "ChartBar",
  props: {
    chartData: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 400
    },
    dataIsLoaded: {
      type: Boolean,
      default: false
    },
    isStacked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canvasId: this.$utils.generateClientId()
    }
  },
  mounted() {
    if (this.dataIsLoaded) {
      this.$nextTick(() => {
        this.buildChart();
      })
    }
  },
  watch: {
    dataIsLoaded(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.buildChart();
        })
      }
    }
  },
  methods: {
    buildChart() {
      new Chart(document.getElementById(this.canvasId), {
        type: 'bar',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            align: 'end',
            labels: {
              boxWidth: 16,
              fontSize: 16,
              padding: 20
            }
          },
          hover: {
            onHover: function (e) {
              let point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = 'pointer';
              else e.target.style.cursor = 'default';
            }
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            },
            xAxes: [{
              stacked: true,
              gridLines: {
                display: true
              }
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
              }
            }]
          },
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.chart-container {
  position: relative;
  margin: auto;
  width: 100%;
}
</style>
